import { render, staticRenderFns } from "./Ingredients.vue?vue&type=template&id=5cb26ab6&scoped=true"
import script from "./Ingredients.vue?vue&type=script&lang=ts"
export * from "./Ingredients.vue?vue&type=script&lang=ts"
import style0 from "./Ingredients.vue?vue&type=style&index=0&id=5cb26ab6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb26ab6",
  null
  
)

export default component.exports